module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"br":{"action":"Ver Detalhes"},"en":{"action":"See Details"},"es":{"action":"Ver detalles"}}')
  delete Component.options._Ctor
}
